import type { IconifyIcon } from '@iconify/types'

export default {
  body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></g>',
  width: 24,
  height: 24
} satisfies IconifyIcon
